import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// If env vars are missing we export null and the app shows a clear config warning
// rather than throwing a blank screen.
export const supabase = url && anonKey ? createClient(url, anonKey) : null;
